import { useState, useCallback, useEffect } from "react"
import History from "./history"
import useUnmounted from "../hooks/useUnmounted"

const pushSearch = params => {
    if (!params || Object.keys(params).length === 0) History.push(window.location.pathname)
    else {
        const search = Object.keys(params)
            .map(key => `${key}=${params[key]}`)
            .join("&")
        History.push(`${window.location.pathname}?${search}`)
    }
}
export default function useHistory() {
    const unmounted = useUnmounted()
    const [location, setLocation] = useState(History.getLocation())

    const handleLocationChange = useCallback(
        (pathname, search, language, sanitized) => {
            if (unmounted.current) return

            setLocation({ pathname, search, language, sanitized })
        },
        [unmounted]
    )
    useEffect(() => {
        History.addLocationListener(handleLocationChange)

        return () => History.removeLocationListener(handleLocationChange)
    }, [handleLocationChange])
    return {
        location,
        push: History.push,
        pushSearch,
    }
}
